<template>
   <div class="mask-box">
    <div class="cart-number-box">
        <div class="product">
            <div class="product-img">
                <img :src="product.image" />
            </div>
            <div class="product-info">
                <div class="product-title">{{product.title}}</div>
                <div class="product-price">￥{{product.price}}</div>
                <div class="product-stock">库存：{{product.stock_count}}</div>
            </div>
            <div class="cart-close" @click="onClose">
                <i class="el-icon-circle-close"></i>
            </div>
        </div>
        <div class="number">
            <div class="number-title">数量</div>
            <div class="number-input">
                <el-input-number size="small" v-model="num" :min="1" :max="product.stock_count" @change="numberChange"></el-input-number>
            </div>
        </div>
        <div class="btn-box">
            <el-button type="danger" class="btn-submit"  @click="onSubmit">确认</el-button>
        </div>
    </div>
   </div>
</template>

<script>
export default {
  name: 'CartNumberComponent',
  props: {
    product: {
        types: Object,
        default: null,
        required: true
    },
    pnum:{
        types: Number,
        default: 1
    },
   },
  data () {
    return {
        num: this.pnum
    }
  },
  components: {
  },
  computed: {
  },
  methods: {
    numberChange (num) {
      let stock = this.product.stock_count
      if (num > stock) {
        this.warning('库存不足')
      } else {
        this.num = num
      }
    },
    onClose () {
       this.$emit('close', false)
    },
    onSubmit () {
        let stock = this.product.stock_count
        if (this.num > stock) {
            this.warning('库存不足')
        }
        this.$emit('num', this.num)
    },
    onCart () {
      let num = this.num
      let id = this._id
      if (!id || !num) {
        this.warning('库存不足')
        return false
      }
      cartAdd(id, num).then( (res) => {
        if (res.code === 200) {
          this.$router.push({name: 'order'})
        } else {
          this.error(res.message)
        }
      })

    },
    onChangeNumber () {
      if (this.to) {
        this.$router.push({name: this.to})
      } else {
        this.$router.back(-1)
      }
      this.$emit('back')
    },
  },
  mounted: function () {
  }
}
</script>
<style lang="scss" scoped>
.mask-box {
    position: fixed;
    top: 0;
    width: 100%;
    min-height: 100vh;
    background-color: rgba($color: #000000, $alpha: 0.3);
    z-index: 888;
}
.cart-number-box {
    position: fixed;
    bottom: 0;
    background-color: #fefefe;
    width: 100%;
    z-index: 9999;
    padding-bottom: 20px;
    .product {
        padding: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background-color: #ffffff;
        .product-img {
            width: 100px;
            height: 100px;
            img {
                width: 98px;
                height: 98px;
                border: solid 1px #cccccc;
            }
        }
        .product-info {
            padding: 0 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .product-title {
                font-size: 16px;
                line-height: 22px;
                height: 44px;
                overflow: hidden;
            }
            .product-price {
                font-size: 16px;
                color: #ec5151;
            }
            .product-stock {
                font-size: 16px;
                color: #999999;
            }

        }
        .cart-close {
            width: 50px;
            font-size: 18px;
            text-align: center;
        }
    }
    .number,.btn-box {
        padding: 0 10px;
    }
    .number {
        .number-title {
            padding: 8px 0;
        }
    }
    .btn-box {
        padding-top: 10px;
        .btn-submit {
            width: 100%;
        }
    }
}
</style>
